module.exports = __webpack_public_path__ + "img/icon_dg@2x.e287d28b.png";